// extracted by mini-css-extract-plugin
export default {"root":"Notifications_root__T84Or","notification":"Notifications_notification__F8Imj","notificationBody":"Notifications_notificationBody__qk4G4"};